import React from "react";

const Dropdown1 = () => {
  return <div className="dropdown-1">Dropdown 1</div>;
};

export default Dropdown1;
